import { Component } from '@angular/core';
import { Analytics } from '@services/analytics';

@Component({
  selector: 'kt-app',
  templateUrl: './index.component.html',
})
export class PublicComponent {
  constructor(analyticsService: Analytics) {
    const url: string = window.location.href;
    analyticsService.reportNavigation(url);
  }
}
